import { useState,} from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddLanguage, ILanguage } from "../../Language.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddLanguage = () => {
  const [formData, setFormData] = useState<IAddLanguage>({
    languageName: "",
    languageCode: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [language, setLanguage] = useState<ILanguage | null>(null);

  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit: SubmitHandler<IAddLanguage> = async () => {
    try {
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.createlanguage}`,
        data: {
          languageName: formData.languageName,
          languageCode: formData.languageCode,
        },
      });

      if (response !== "undefined") {
        toast.success("Language added successfully", {
          duration: 10000, // Set the duration in milliseconds
        });
        navigate("/language"); // Redirect after successful update
      }
    } catch (error) {
      toast.error("Error updating status", {
        duration: 10000, // Set the duration in milliseconds
      });
      console.error("Error updating language:", error);
    }
  };

  const handleCancel = () => {
    navigate("/language");
  };

  return {
    loading,
    formData,
    language,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddLanguage;
